import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { MenuItem, FormControl, Select, InputLabel } from '@mui/material';
import { useStores } from '../../hooks/use-stores';
import orderBy from 'lodash/orderBy';
import { every } from 'lodash';

function LanguageSelector({
                              handleSelectLanguage,
                              selectedLanguage,
                              availableLanguages = ['en'],
                          }) {
    const { commonStore } = useStores();

    const [languages, setLanguages] = useState([]);

    useEffect(() => {
        translateLanguageKeys();
    }, [availableLanguages]);

    /** Get the english, human-readable, name of languages */
    const translateLanguageKeys = () => {
        const codesOnly = every(availableLanguages, (lang) => typeof lang === 'string');

        if(!codesOnly) {
            availableLanguages = availableLanguages.map((x) => x.code);
        }
        const readableLanguages = availableLanguages.map((x) => ({
            id: x,
            name: commonStore.languagesIndex[x]
                ? commonStore.languagesIndex[x].english_name
                : x,
        }));
        setLanguages(orderBy(readableLanguages, ['name'], ['asc']));
    };

    return (
        <FormControl
            className="ag-language-select"
            variant="outlined"
            size="small"
            sx={{ minWidth: 150, maxWidth: 200 }}
        >
            <InputLabel id="language-select-label">Language</InputLabel>
            <Select
                labelId="language-select-label"
                value={selectedLanguage}
                label="Language"
                size="small"
                onChange={(e) => handleSelectLanguage(e.target.value)}
                MenuProps={{
                    PaperProps: { className: 'ag-language-select-menu' },
                }}
            >
                {languages.map((x) => {
                    return (
                        <MenuItem
                            value={x.id}
                            key={x.id}
                        >
                            {x.name}
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
}

export default observer(LanguageSelector);
